import { ReactElement } from 'react';
import FontAwesomeIcon from '../../../../../../ui/font-awesome-icon/font-awesome-icon';
import './material-school-label.scss';

const SCHOOL_ICONS = [1, 2, 3, 4] as const;

const MaterialSchoolLabel = (): ReactElement => (
    <div className='material-school-label'>
        {SCHOOL_ICONS.map((key) => (
            <FontAwesomeIcon key={key} width={20} height={20} name='school' />
        ))}
    </div>
);

export default MaterialSchoolLabel;
